// extracted by mini-css-extract-plugin
export default {"main":"_xFqeH2Hb8I9UGgRBWqp","payoutSetup":"IaUrTGVdTYvS8RYBuU3m","optionalBadge":"sio6NTpixM2sXeaWcMzK"};